// extracted by mini-css-extract-plugin
export default {"root":"_1_uYBnFr","settings":"_2qcnL_BL","close":"lXy_Qdac"};